import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Импортируем useNavigate
import { Box, Typography, Container, CircularProgress, Paper, List, ListItem, ListItemText, Divider, Grid, Card, CardContent, Button } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material'; // Импортируем иконку
import { organizationService } from '../../services/organizationService'; // Импортируем organizationService
import { OrganizationDTO } from '../../types/organization'; // Импортируем OrganizationDTO

const OrganizationsListPage: React.FC = () => {
  const [organizations, setOrganizations] = useState<OrganizationDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate(); // Инициализируем useNavigate

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await organizationService.getAllPlatformOrganizations();
        setOrganizations(data);
      } catch (err) {
        console.error("Ошибка при получении списка организаций:", err);
        setError("Не удалось загрузить список организаций.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  const handleViewTasks = (organizationId: string) => {
    // Здесь будет переход на страницу с задачами для конкретной организации
    navigate(`/admin/organizations/${organizationId}`); 
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Список Организаций
        </Typography>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Typography color="error" sx={{ mt: 4 }}>
            {error}
          </Typography>
        )}
        {!loading && !error && organizations.length === 0 && (
          <Typography variant="body1" sx={{ mt: 4 }}>
            Организации не найдены.
          </Typography>
        )}
        {!loading && !error && organizations.length > 0 && (
          <Grid container spacing={3} sx={{ mt: 4 }}>
            {organizations.map((org) => (
              <Grid item xs={12} sm={6} md={4} key={org.id}>
                <Card 
                  elevation={3} 
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: '0.3s',
                    '&:hover': { transform: 'translateY(-5px)' },
                    cursor: 'pointer',
                  }}
                  onClick={() => handleViewTasks(org.id)}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      {org.icon ? (
                        <img src={org.icon} alt="Organization Icon" style={{ width: 40, height: 40, marginRight: 16, borderRadius: '50%' }} />
                      ) : (
                        <BusinessIcon sx={{ fontSize: 40, mr: 2, color: 'primary.main' }} />
                      )}
                      <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                        {org.name}
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      ИНН: {org.inn || 'Не указано'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Директор: {org.directorFullName || 'Не указано'}
                    </Typography>
                    {/* Добавьте другие поля по желанию */}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Container>
  );
};

export default OrganizationsListPage;
